//GLOBAL - components from npm
import React, { useMemo, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import MicroModal from "micromodal";
import { AutoSizer, Grid } from "react-virtualized";

//COMPONENTS
import TeamModal from "../../modals/TeamModal";
import Drawer from "../../components/manager-section/Drawer/Drawer";
import ManagerPerfomance from "../ManagerPerfomance";
import ChatSimultComponent from "../../containers/ChatSimult";
import MonitoringDashboardV2 from "../../components/modals/ModalMonitoringDashV2/ModalMonitoringDashV2";
import "../../build/css/internal-manager.css";

//GLOBAL STATE - redux, env...
import {
  EfectBlockUser,
  BlockUserInable,
  UserSupDesbloqInable,
} from "../../actions";
import { Tooltippy } from "../../actions/Tippy";

//ASSETS - icons, images...
import { ReactComponent as EMCURSO } from "../../build/images/teams/monitorias/message-1.svg";
import { ReactComponent as Search } from "../../build/images/teams/search-normal.svg";
import { ReactComponent as Filter } from "../../build/images/teams/filter.svg";
import { ReactComponent as QtdTotalIcon } from "../../build/images/teams/status-info/profile-2user.svg";
import { ReactComponent as LivresIcon } from "../../build/images/teams/status-info/message-search.svg";
import { ReactComponent as PausadosIcon } from "../../build/images/teams/status-info/timer-pause.svg";
import { ReactComponent as InteracoesIcon } from "../../build/images/teams/status-info/sms-notification.svg";
import { ReactComponent as InativosIcon } from "../../build/images/teams/status-info/profile-remove.svg";
import { ReactComponent as ACWIcon } from "../../build/images/teams/status-info/warning-2.svg";
import { ReactComponent as IconClose } from "../../build/images/closecircle22px.svg";

//UTILS
import { getStorageData } from "../../utils/getStorageData";
import CardUser from "./CardUser";

const { connection_platform } = require("../../services/api");

let gethostname = window.location.hostname;
let pathname = "";

const iplocal = connection_platform.ip_intern;
let port = connection_platform.port_backend_intern;
let portims = connection_platform.port_socket_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

let ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent =
    connection_platform.ip_extern +
    ":" +
    connection_platform.port_apache_view_extern;
  port = connection_platform.port_backend_extern;
  portims = connection_platform.port_socket_extern;
}

port = localStorage.getItem("port");
pathname = localStorage.getItem("pathname");

export default function InternalManagerV2() {
  //GENERAL
  const dispatch = useDispatch();
  const UserGroups = useSelector((state) => state.groups);
  const usersatd = useSelector((state) => state.agents);
  const InfoUsers = useSelector((state) => state.informationusers);

  //STATES
  const [buttonfilter, setButtonfilter] = useState(false);
  const [act, setAct] = useState("1");
  const [showmodal, setShowmodal] = useState(false);
  const [buttonfilter2, setButtonfilter2] = useState(false);
  const [filterGroup, setFilterGroup] = useState("");
  const [auxkeyGen, setAuxkeyGen] = useState([]);
  const [keyGan, setKeyGan] = useState(getStorageData("storageState"));
  const [auxkeyGan, setAuxkeyGan] = useState(getStorageData("storageState"));
  const [keyGen, setKeyGen] = useState(getStorageData("storageGroup"));
  const [actdesb, setActdesb] = useState("1001");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [totalFilters, setTotalFilters] = useState(
    getStorageData("filtersTotal")
  );
  const [textbloqueio, setTextbloqueio] = useState("");
  const [textdesbloqueio, setTextdesbloqueio] = useState("");
  const [filterAgent, setFilterAgent] = useState("");
  const [userout, setUserout] = useState();
  const [horaaction, setHoraaction] = useState();
  const [duration, setDuration] = useState();
  const [reasonaction, setReasonaction] = useState();
  const [inable, setInable] = useState();
  const [idblock, setIdblock] = useState();
  const [idsup, setIdsup] = useState();
  const [monitoringInfo, setMonitoringInfo] = useState("");
  const [monitoringInfoJson, setMonitoringInfoJson] = useState("");

  //USE MEMO
  const groups = useMemo(() => {
    let listin = [];
    if (UserGroups.length != 0) {
      listin = UserGroups.groups;
    } else {
      listin = [];
    }

    const updatedGroups = _.filter(listin, (group) => {
      let arrayGroup = [group.name];
      return !_.isEmpty(filterGroup)
        ? arrayGroup
            .toString()
            .toLowerCase()
            .indexOf(filterGroup.toString().toLowerCase()) > -1
        : true;
    });

    return updatedGroups;
  }, [UserGroups, filterGroup]);

  const groupsSelec = useMemo(() => {
    const updatedGroupsSelec = groups.filter((gs) => keyGen.includes(gs.id));
    return updatedGroupsSelec;
  }, [groups, keyGen]);

  const lsusersatd = useMemo(() => {
    let list = [];
    if (usersatd.length != 0) {
      list = usersatd;
      if (keyGen.length > 0) {
        list = list.filter((agent) => keyGen.includes(agent.id_grupo));
      }
      if (keyGan.length > 0) {
        // this.state.lsusersatd = this.state.lsusersatd.filter(
        //   (agent) =>
        //     this.state.keyGan.includes(agent.status) ||
        //     this.state.keyGan.includes(agent.status_sip)
        // );
        list = list.filter((agent) =>
          keyGan.includes(agent.status, agent.status_sip)
        );
        // this.state.lsusersatd = this.state.lsusersatd.filter(agent => this.state.keyGan.includes(agent.status_sip))
      }
    } else {
      list = [];
    }
    let updatedlsusersatd = [];
    updatedlsusersatd = _.filter(list, (agent) => {
      let arrayAgent = [
        agent.username,
        agent.desc_grupo,
        agent.ramal,
        agent.razao_bloqueio,
      ];
      return !_.isEmpty(filterAgent)
        ? arrayAgent
            .toString()
            .toLowerCase()
            .indexOf(filterAgent.toString().toLowerCase()) > -1
        : true;
    });
    updatedlsusersatd = _.orderBy(updatedlsusersatd, ["label"], ["asc"]);

    return updatedlsusersatd;
  }, [usersatd, keyGen, keyGan, filterAgent]);

  const agentesLivres = useMemo(() => {
    const updatedAgentesLivres = lsusersatd.filter(
      (user) =>
        (user.status_sip === "RV" && user.status === "LV") ||
        (user.status_sip === "LV" && user.status === "LV")
    );

    return updatedAgentesLivres;
  }, [lsusersatd]);

  const agentesPausados = useMemo(() => {
    const updatedAgentesPausados = lsusersatd.filter((user) => {
      return user.status_sip === "BQ" && user.razao_bloqueio !== "";
    });

    return updatedAgentesPausados;
  }, [lsusersatd]);

  const agentesAtendendo = useMemo(() => {
    const updatedAgentesAtendendo = lsusersatd.filter(
      (user) =>
        (user.status_sip === "LV" && user.status === "AT") ||
        (user.status_sip === "AT" && user.status === "AT") ||
        (user.status_sip === "RV" && user.status === "ATOS") ||
        (user.status_sip === "AT" && user.status === "ATOS") ||
        (user.status_sip === "ATOS" && user.status === "AT") ||
        (user.status_sip === "LV" && user.status === "RV") ||
        (user.status_sip === "CHND" && user.razao_bloqueio !== "CHND")
    );

    return updatedAgentesAtendendo;
  }, [lsusersatd]);

  const agentesInativos = useMemo(() => {
    const updatedAgentesInativos = lsusersatd.filter(
      (user) =>
        user.status_sip === null ||
        user.status === null ||
        user.status_sip === "null" ||
        user.status === "null"
    );

    return updatedAgentesInativos;
  }, [lsusersatd]);

  const agentesACW = useMemo(() => {
    const updatedAgentesACW = lsusersatd.filter(
      (user) => user.status_sip === "ACW" && user.status === "ACW"
    );

    return updatedAgentesACW;
  }, [lsusersatd]);

  //DISPATCHS ACTIONS
  function EfectBlockUserAction(userout, act, reason) {
    dispatch(EfectBlockUser(userout, act, reason));
  }
  function UserSupDesbloqInableAction(
    reason,
    idblockdescription,
    idblocksupervision
  ) {
    dispatch(
      UserSupDesbloqInable(reason, idblockdescription, idblocksupervision)
    );
  }

  //FUNCTIONS
  function handleChangeAgentGroup(e) {
    setFilterAgent(e.target.value);
  }
  function handleChangeGroup(e) {
    setFilterGroup(e.target.value);
  }
  function handleSetVisibleDrawer() {
    setOpenDrawer(false);
    setButtonfilter(false);
    setButtonfilter2(false);
  }
  function handleFilterGroup(e, idgroup, description) {
    let filtersgroupstorage = [];
    if (e.target.checked) {
      setKeyGen((prevKeyGen) => {
        const updatedKeyGen = prevKeyGen.concat([idgroup]);
        return updatedKeyGen;
      });
      setAuxkeyGen((prevAuxkeyGen) => {
        return prevAuxkeyGen.concat([idgroup]);
      });
      setTotalFilters((prevTotalFilters) => {
        return prevTotalFilters.concat([idgroup]);
      });
      filtersgroupstorage = keyGen.concat([idgroup]);
    } else {
      setKeyGen((prevKeyGen) => {
        return prevKeyGen.filter(function (val) {
          return val != idgroup;
        });
      });
      setAuxkeyGen((prevAuxkeyGen) => {
        return prevAuxkeyGen.filter(function (val) {
          return val != idgroup;
        });
      });
      setTotalFilters((prevTotalFilters) => {
        return prevTotalFilters.filter(function (val) {
          return val != idgroup;
        });
      });

      handleRemoveGroupSelec(e, idgroup);
      filtersgroupstorage = keyGen.filter(function (val) {
        return val != idgroup;
      });
    }
    localStorage.setItem("managerinternal_filter_group", filtersgroupstorage);
  }
  function handleFilterState(e, status) {
    let filterstatestorage = [];
    if (e.target.checked) {
      filterstatestorage = keyGan.concat([status]);
      if (status === "AT") {
        filterstatestorage = filterstatestorage.concat(["ATOS"]);
        filterstatestorage = filterstatestorage.concat(["CHND"]);
        filterstatestorage = filterstatestorage.concat(["RV"]);
      }
      setKeyGan(filterstatestorage);
      setAuxkeyGan(filterstatestorage);
      setTotalFilters((prevTotalFilters) => {
        return prevTotalFilters.concat([status]);
      });
    } else {
      filterstatestorage = keyGan.filter(function (val) {
        return val != status;
      });
      if (status === "AT") {
        filterstatestorage = filterstatestorage.filter(function (val) {
          return val != "ATOS";
        });
        filterstatestorage = filterstatestorage.filter(function (val) {
          return val != "CHND";
        });
        filterstatestorage = filterstatestorage.filter(function (val) {
          return val != "RV";
        });
      }
      setKeyGan(filterstatestorage);
      setAuxkeyGan(filterstatestorage);
      setTotalFilters((prevTotalFilters) => {
        return prevTotalFilters.filter(function (val) {
          return val != status;
        });
      });
    }
    localStorage.setItem("managerinternal_filter_state", filterstatestorage);
  }
  function handleShowFilters(e) {
    e.preventDefault();
    setButtonfilter((prevButtonfilter) => {
      return !prevButtonfilter;
    });
  }
  function handleShowFilters2(e) {
    e.preventDefault();
    setButtonfilter2((prevButtonfilter2) => {
      return !prevButtonfilter2;
    });
  }
  function handleRemoveStateSelec(e, id) {
    e.stopPropagation();
    document.getElementById("checkbox-" + id).click();
  }
  function handleRemoveGroupSelec(e, id) {
    e.stopPropagation();
    document.getElementById("checkbox-geral" + id).click();
  }
  function handleRemoveAllGroup(e) {
    let array = groupsSelec;
    for (let i = 0; i < array.length; i++) {
      let myCheckbox = document.getElementById("checkbox-geral" + array[i].id);
      myCheckbox.checked = false;
    }
    setKeyGen([]);
    setAuxkeyGen([]);
    localStorage.setItem("managerinternal_filter_group", []);
  }
  function handleRemoveAllState(e) {
    let array = keyGan.filter(
      (val) => val !== "ATOS" && val !== "CHND" && val !== "RV"
    );
    for (let i = 0; i < array.length; i++) {
      let myCheckbox = document.getElementById("checkbox-" + array[i]);
      myCheckbox.checked = false;
    }
    setKeyGan([]);
    setAuxkeyGan([]);
    localStorage.setItem("managerinternal_filter_state", []);
  }
  function handleActionUserSup(e, modal) {
    //let reason = document.getElementById("anotc-add__textarea__input").value;
    let reason = textbloqueio;
    dispatch(EfectBlockUser(userout, act, reason));
    setAct("1");
    MicroModal.close(modal);
  }
  function handleActionBlockUserInable(e, modal) {
    //let reason = document.getElementById("anotc-add__textarea__input").value;
    let reason = textbloqueio;
    dispatch(BlockUserInable(userout, reason));
    MicroModal.close(modal);
  }
  function handleActionUserSupDesbloq(e, modal) {
    //let reason = document.getElementById("anotc-add__textarea__input-desb").value;
    let reason = textdesbloqueio;
    EfectBlockUserAction(userout, act, reason);
    setAct("1");
    MicroModal.close(modal);
  }
  function handleActionUserSupDesbloqInable(e, modal) {
    //let reason = document.getElementById("anotc-add__textarea__input-desb").value;
    let reason = textdesbloqueio;
    UserSupDesbloqInableAction(reason, idblock, idsup);
    MicroModal.close(modal);
  }
  function handleAlterBlockAction(e, value) {
    setAct(value);
    if (value === "1") {
      document.getElementById("logout-atd").checked = false;
    } else {
      document.getElementById("block-atd").checked = false;
    }
  }
  function handleAlterBlockActionDesb(e, value) {
    setActdesb(value);
    if (value === "1001") {
      document.getElementById("radio-22").checked = false;
    } else {
      document.getElementById("radio-11").checked = false;
    }
  }
  function handleShowTeamModal() {
    MicroModal.show("modal__mensagem-equipe");
  }
  const closeMonitoring = useCallback(() => {
    setMonitoringInfo("");
    setMonitoringInfoJson("");
  }, []);

  return (
    <div className="canvas__wrapper">
      <div className="canvas__wrapper__body equipe-page">
        <div className="column-model--overflow w-auto atendente-gestor new-internal-manager-no-overflow">
          <div className="column-model__body">
            <div className="column-model__body__block">
              <div className="box">
                <div className="box__title">Equipes</div>

                <div className="box__body">
                  <div className="card card--med">
                    <div className="full-search">
                      <input
                        type="text"
                        name="client-search"
                        id="client-search"
                        placeholder="Pesquisar atendente"
                        onChange={(event) => handleChangeAgentGroup(event, "")}
                      />
                      <button type="submit" className="full-search__btn">
                        {/* <i className="material-icons">search</i> */}
                        <Search />
                      </button>
                    </div>

                    <div className="actions">
                      <div
                        className="actions__item"
                        onClick={(event) => {
                          return setOpenDrawer(true);
                        }}
                      >
                        <Filter />
                        <span>Filtros</span>
                        {totalFilters.length > 0 && (
                          <span className="total-filters">
                            {totalFilters.length}
                          </span>
                        )}
                      </div>
                      {/* <div className="actions__item tippy-default" data-tippy="Conferência de grupo">
                                    <Tooltippy content={'Conferência de grupo'}><a><ACCOUNT /></a></Tooltippy>
                                    </div>
                                    <div className="actions__item tippy-default" data-tippy="Transferência de grupo">
                                    <Tooltippy content={'Transferência de grupo'}><a><SWITCH /></a></Tooltippy>
                                    </div> */}
                      <div
                        className="actions__item secundary_item tippy-default"
                        onClick={(event) => handleShowTeamModal(event)}
                        data-tippy="Chat de grupo"
                      >
                        <Tooltippy content={"Chat de grupo"}>
                          <EMCURSO />
                          <span>Mensagem</span>
                        </Tooltippy>
                      </div>
                    </div>
                  </div>

                  {/* {(() => {
                    if (this.state.groupsSelec.length != 0) {
                      return (
                        <div
                          className={
                            this.state.buttonfilter
                              ? "box__body__filter-content active"
                              : "box__body__filter-content"
                          }
                        >
                          <div className="card-preview card-preview--close-all">
                            <div
                              className="card-preview--close-all__icon"
                              onClick={(event) => this.RemoveAllGroup(event)}
                            >
                              <i className="material-icons">close</i>
                            </div>
                            <div
                              className="card-preview--close-all__text"
                              onClick={(event) => this.RemoveAllGroup(event)}
                            >
                              Fechar todos
                            </div>
                          </div>
                          {this.state.groupsSelec.map((gs, index) => (
                            <div className="card-preview" key={index}>
                              <div
                                className="card-preview__text"
                                onClick={(event) =>
                                  this.RemoveGroupSelec(event, gs.id)
                                }
                              >
                                {gs.name}
                              </div>
                              <div className="card-preview__icon">
                                <i
                                  onClick={(event) =>
                                    this.RemoveGroupSelec(event, gs.id)
                                  }
                                  className="material-icons"
                                >
                                  close
                                </i>
                              </div>
                            </div>
                          ))}
                        </div>
                      );
                    }
                  })()} */}
                </div>

                <div className="box__body-footer">
                  <div className="status__info-box">
                    <div className="icon-v2">
                      <QtdTotalIcon />
                    </div>
                    <div className="info">
                      <span>Qtd. total:</span> {lsusersatd.length}
                    </div>
                  </div>
                  <div className="status__info-box">
                    <div className="icon-v2">
                      <LivresIcon />
                    </div>
                    <div className="info">
                      <span>Livres:</span> {agentesLivres.length}
                    </div>
                  </div>
                  <div className="status__info-box">
                    <div className="icon-v2">
                      <PausadosIcon />
                    </div>
                    <div className="info">
                      <span>Pausados:</span> {agentesPausados.length}
                    </div>
                  </div>
                  <div className="status__info-box">
                    <div className="icon-v2">
                      <InteracoesIcon />
                    </div>
                    <div className="info">
                      <span>Atendimentos:</span> {agentesAtendendo.length}
                    </div>
                  </div>
                  <div className="status__info-box">
                    <div className="icon-v2">
                      <InativosIcon />
                    </div>
                    <div className="info">
                      <span>Inativo:</span> {agentesInativos.length}
                    </div>
                  </div>
                  <div className="status__info-box">
                    <div className="icon-v2">
                      <ACWIcon />
                    </div>
                    <div className="info">
                      <span>ACW:</span> {agentesACW.length}
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  flex: 1,
                  width: "100%",
                  height: "calc(100% - 10px)",
                }}
              >
                <AutoSizer>
                  {({ height, width }) => {
                    const cellMinWidth = 200; // Largura mínima da célula
                    const cellMaxWidth = 260; // Largura máxima da célula
                    const gap = 10; // Espaçamento entre colunas e linhas
                    const columnWidth = Math.min(
                      cellMaxWidth,
                      Math.max(cellMinWidth, width)
                    );
                    const cellHeight = 230; // Altura fixa do card

                    // Calcula o número de colunas baseado na largura disponível
                    const columnCount = Math.max(
                      1,
                      Math.floor((width + gap) / (columnWidth + gap)) // Número de colunas
                    );

                    // Calcula o número de linhas baseado no total de itens
                    const rowCount = Math.ceil(lsusersatd.length / columnCount);

                    const cellRenderer = ({
                      columnIndex,
                      key,
                      rowIndex,
                      style,
                    }) => {
                      const index = rowIndex * columnCount + columnIndex;
                      if (index >= lsusersatd.length) return null;

                      const user = lsusersatd[index];

                      return (
                        <div
                          key={key}
                          className="internal-manager-ondemand-card"
                          style={{
                            ...style,
                            flex: 1,
                            padding: `${gap / 2}px`,
                            boxSizing: "border-box",
                          }}
                        >
                          <CardUser
                            key={index}
                            user={user}
                            bind={this}
                            setUserout={setUserout}
                            setHoraaction={setHoraaction}
                            setDuration={setDuration}
                            setReasonaction={setReasonaction}
                            setActdesb={setActdesb}
                            setInable={setInable}
                            setIdblock={setIdblock}
                            setIdsup={setIdsup}
                            connection_platform={connection_platform}
                            pathname={pathname}
                            port={port}
                            act={act}
                            setAct={setAct}
                            setMonitoringInfo={setMonitoringInfo}
                            setMonitoringInfoJson={setMonitoringInfoJson}
                          />
                        </div>
                      );
                    };

                    return (
                      <Grid
                        className="internal-manager-v2-autosizer-grid"
                        columnCount={columnCount}
                        rowCount={rowCount}
                        columnWidth={columnWidth}
                        rowHeight={cellHeight}
                        width={width}
                        height={height}
                        style={{
                          boxSizing: "border-box",
                        }}
                        cellRenderer={cellRenderer}
                      />
                    );
                  }}
                </AutoSizer>
              </div>
              <div className="box">
                {/* <div className="box__title">Site</div> */}

                {/*<div className="box__body">
                  {this.state.lsusersatd.map((user, index) => (
                    <>
                      {(() => (
                        <CardUser
                          key={index}
                          user={user}
                          bind={this}
                          {...this.props}
                        />
                      ))()}
                    </>
                  ))}
                </div>*/}
              </div>

              {/* <div className="box">
                              <div className="box__title">
                                Site Ingenium System
                              </div>
                            </div> */}
            </div>
          </div>
          <div
            className="modal micromodal-slide"
            id="modal__bloqueio"
            aria-hidden="true"
            role="dialog"
          >
            <div className="modal__overlay" tabIndex="-1">
              <div
                className="modal__container"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal__bloqueio__title"
              >
                <header className="modal__header">
                  <h2 className="modal__title" id="modal__bloqueio__title">
                    Bloqueio
                  </h2>

                  <button
                    className="modal__close"
                    aria-label="Close modal"
                    data-micromodal-close
                  ></button>
                </header>
                <div className="modal__header__bottom-line"></div>
                <main
                  className="modal__content modal__content--small"
                  id="modal__bloqueio__content"
                >
                  <div className="modal__content__user-details__content">
                    <form action="" className="modal__content__form">
                      <div className="modal__content__form__group modal__content__form__group--col-8">
                        <div className="modal__content--left">
                          <h3 className="modal-box__warning is-poppins">
                            Razão do bloqueio <br />
                          </h3>

                          <p className="modal-box__message">
                            Descreva a razão do bloqueio para o atendente
                          </p>
                        </div>

                        <div className="modal__content__form__group modal__content__form__group--col-8"></div>
                        <div className="radio-content radio-content--column">
                          <div className="radio-button">
                            <input
                              type="radio"
                              id="block-atd"
                              name="block-atd"
                              onClick={(event) =>
                                handleAlterBlockAction(event, "1")
                              }
                              defaultChecked={act === "1" ? true : false}
                            />
                            <label htmlFor="block-atd">
                              <span>
                                <div className="mask"></div>
                              </span>

                              <div className="text">Bloquear</div>
                            </label>
                          </div>
                          {(() => {
                            if (inable === false) {
                              return (
                                <div className="radio-button">
                                  <input
                                    type="radio"
                                    id="logout-atd"
                                    name="logout-atd"
                                    onClick={(event) =>
                                      handleAlterBlockAction(event, "2")
                                    }
                                    defaultChecked={act === "2" ? true : false}
                                  />
                                  <label htmlFor="logout-atd">
                                    <span>
                                      <div className="mask"></div>
                                    </span>

                                    <div className="text">
                                      Logout do atendente
                                    </div>
                                  </label>
                                </div>
                              );
                            }
                          })()}
                        </div>
                      </div>

                      <div className="modal__content__form__group modal__content__form__group--col-8">
                        <div className="anotc-add__textarea">
                          <textarea
                            name="anotc-add__textarea__input"
                            id="anotc-add__textarea__input"
                            className="anotc-add__textarea__input"
                            value={textbloqueio}
                            onChange={(e) => {
                              return setTextbloqueio(e.target.value);
                            }}
                          ></textarea>
                        </div>
                      </div>

                      <div className="modal__content__form__group modal__content__form__group--col-1"></div>
                      <div className="modal__content__form__group modal__content__form__group--col-3">
                        <a
                          className="modal__content__form__group__button modal__content__form__group__button--white"
                          data-micromodal-close
                        >
                          Cancelar
                        </a>
                      </div>
                      <div className="modal__content__form__group modal__content__form__group--col-3">
                        {(() => {
                          if (inable === false) {
                            return (
                              <a
                                className="modal__content__form__group__button "
                                onClick={(event) => {
                                  return handleActionUserSup(
                                    event,
                                    "modal__bloqueio"
                                  );
                                }}
                              >
                                OK
                              </a>
                            );
                          } else {
                            return (
                              <a
                                className="modal__content__form__group__button "
                                onClick={(event) => {
                                  return handleActionBlockUserInable(
                                    event,
                                    "modal__bloqueio"
                                  );
                                }}
                              >
                                OK
                              </a>
                            );
                          }
                        })()}
                      </div>
                    </form>
                  </div>
                </main>
              </div>
            </div>
          </div>
          <div
            className="modal micromodal-slide"
            id="modal__desbloqueio"
            aria-hidden="true"
            role="dialog"
          >
            <div className="modal__overlay" tabIndex="-1">
              <div
                className="modal__container"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal__desbloqueio__title"
              >
                <header className="modal__header">
                  <h2 className="modal__title" id="modal__desbloqueio__title">
                    Desbloqueio
                  </h2>

                  <button
                    className="modal__close"
                    aria-label="Close modal"
                    data-micromodal-close
                  ></button>
                </header>
                <div className="modal__header__bottom-line"></div>
                <main
                  className="modal__content modal__content--small"
                  id="modal__desbloqueio__content"
                >
                  <div className="modal__content__user-details__content">
                    <form action="" className="modal__content__form">
                      <div className="modal__content__form__group modal__content__form__group--col-8">
                        <div className="modal__content--left">
                          <h3 className="modal-box__warning is-poppins">
                            Razão do bloqueio <br />
                          </h3>

                          <p className="modal-box__message">
                            Descreva a razão do desbloqueio para o atendente
                          </p>
                        </div>

                        <div className="modal__content__form__group modal__content__form__group--col-8"></div>
                        <div className="radio-content radio-content--column">
                          <div className="radio-button">
                            <input
                              type="radio"
                              id="radio-11"
                              name="radio-11"
                              onClick={(event) => {
                                return handleAlterBlockActionDesb(
                                  event,
                                  "1001"
                                );
                              }}
                              defaultChecked={
                                actdesb === "1001" ? "checked" : ""
                              }
                            />
                            <label htmlFor="radio-11">
                              <span>
                                <div className="mask"></div>
                              </span>

                              <div className="text">Desbloquear</div>
                            </label>
                          </div>
                          {(() => {
                            if (inable === false) {
                              return (
                                <div className="radio-button">
                                  <input
                                    type="radio"
                                    id="radio-22"
                                    name="radio-22"
                                    onClick={(event) => {
                                      return handleAlterBlockActionDesb(
                                        event,
                                        "3"
                                      );
                                    }}
                                    defaultChecked={
                                      actdesb === "3" ? "checked" : ""
                                    }
                                  />
                                  <label htmlFor="radio-22">
                                    <span>
                                      <div className="mask"></div>
                                    </span>

                                    <div className="text">
                                      Logout do atendente
                                    </div>
                                  </label>
                                </div>
                              );
                            }
                          })()}
                        </div>
                      </div>

                      <div className="modal__content__form__group modal__content__form__group--col-8">
                        <div className="modal__content__form__group__desc">
                          {/* <div className="modal__content__form__group__desc__item">
                                            <strong>Bloqueado por:</strong>
                                            Gabriel Ferreira
                                          </div> */}
                          <div className="modal__content__form__group__desc__item">
                            <strong>Data de bloqueio:</strong>
                            {" " + duration}
                          </div>
                          <div className="modal__content__form__group__desc__item">
                            <strong>Hora de bloqueio:</strong>
                            {" " + horaaction}
                          </div>
                          <div className="modal__content__form__group__desc__item">
                            <strong>Razão do bloqueio:</strong>
                            <span>{" " + reasonaction}</span>
                          </div>
                        </div>
                      </div>

                      <div className="modal__content__form__group modal__content__form__group--col-8">
                        <div className="anotc-add__textarea">
                          <textarea
                            name="anotc-add__textarea__input"
                            id="anotc-add__textarea__input-desb"
                            className="anotc-add__textarea__input"
                            value={textdesbloqueio}
                            onChange={(e) => {
                              return setTextdesbloqueio(e.target.value);
                            }}
                          ></textarea>
                        </div>
                      </div>

                      <div className="modal__content__form__group modal__content__form__group--col-1"></div>
                      <div className="modal__content__form__group modal__content__form__group--col-3">
                        <a
                          className="modal__content__form__group__button modal__content__form__group__button--white"
                          data-micromodal-close
                        >
                          Cancelar
                        </a>
                      </div>
                      <div className="modal__content__form__group modal__content__form__group--col-3">
                        {(() => {
                          if (inable === false) {
                            return (
                              <a
                                className="modal__content__form__group__button "
                                onClick={(event) => {
                                  return handleActionUserSupDesbloq(event);
                                }}
                              >
                                OK
                              </a>
                            );
                          } else {
                            return (
                              <a
                                className="modal__content__form__group__button "
                                onClick={(event) => {
                                  return handleActionUserSupDesbloqInable(
                                    event
                                  );
                                }}
                              >
                                OK
                              </a>
                            );
                          }
                        })()}
                      </div>
                    </form>
                  </div>
                </main>
              </div>
            </div>
          </div>
          <div
            className="modal micromodal-slide"
            id="modal__mensagem-equipe"
            aria-hidden="true"
            role="dialog"
          >
            <TeamModal showmodal={showmodal} />
          </div>
          {monitoringInfo && (
            <MonitoringDashboardV2
              attendant={monitoringInfo}
              infoJson={monitoringInfoJson}
              onClose={closeMonitoring}
            />
          )}
        </div>

        {/* {(() => {
          if (InfoUsers.supervisor === true) return <ManagerPerfomance />;
        })()} */}
        <Drawer
          filterApply={false}
          isOpen={openDrawer}
          setCloseDrawer={handleSetVisibleDrawer}
          bind={this}
          filtersActive={totalFilters}
          cleanFilters={(e) => {
            handleRemoveAllGroup(e);
            handleRemoveAllState(e);
            setTotalFilters([]);
          }}
          title="Filtros"
        >
          <div className="field-select">
            <label htmlFor="mult-filter-inside">Grupos</label>
            <div
              className={
                buttonfilter
                  ? "select card--no-mg active"
                  : "select card--no-mg"
              }
            >
              <button
                className="select__btn"
                type="button"
                id="mult-filter-inside"
                onClick={handleShowFilters}
              >
                {groupsSelec.length > 0 ? (
                  <div className="cards-preview">
                    {groupsSelec.map((gs, index) => (
                      <div className="card-preview" key={index}>
                        <div
                          className="card-preview__text"
                          onClick={(event) =>
                            handleRemoveGroupSelec(event, gs.id)
                          }
                        >
                          {gs.name}
                        </div>
                        <div className="card-preview__icon">
                          <i
                            onClick={(event) =>
                              handleRemoveGroupSelec(event, gs.id)
                            }
                            className="material-icons"
                          >
                            close
                          </i>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  "Grupos"
                )}
                <div className="cards-preview__select-icons">
                  {groupsSelec.length > 0 && (
                    <IconClose
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveAllGroup(e);
                      }}
                    />
                  )}
                  <i className="select__icon material-icons">
                    keyboard_arrow_right
                  </i>
                </div>
              </button>
              <div className="options options--advanced">
                <div className="options--advanced__search-box">
                  <div className="full-search">
                    <input
                      type="text"
                      name="client-search"
                      id="client-search"
                      placeholder="Busca..."
                      onChange={(event) => handleChangeGroup(event)}
                    />
                    <button type="submit" className="full-search__btn">
                      <i className="material-icons">search</i>
                    </button>
                  </div>
                </div>
                <div className="options--advanced__filter-box">
                  <div className="options--advanced__filter-box__content">
                    {/* <!-- Grupos --> */}
                    {/* <div className="checkbox__list__title">Grupos</div> */}
                    <div className="checkbox checkbox__list">
                      {groups.map((group) => (
                        <li className="checkbox__item" key={group.id}>
                          <input
                            className="checkbox__list__input"
                            id={"checkbox-geral" + group.id}
                            name={"checkbox-geral" + group.id}
                            type="checkbox"
                            defaultChecked={
                              keyGen.findIndex(function (val) {
                                return val === group.id;
                              }) !== -1
                                ? true
                                : false
                            }
                            onChange={(event) =>
                              handleFilterGroup(event, group.id, group.name)
                            }
                            value="Geral"
                          />
                          <label htmlFor={"checkbox-geral" + group.id}>
                            {group.name}
                          </label>
                        </li>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="field-select">
            <label htmlFor="mult-filter-inside2">Status</label>
            <div className={buttonfilter2 ? "select active" : "select "}>
              <button
                id="mult-filter-inside2"
                className="select__btn"
                type="button"
                data-pausa="Atendimento Presencial Cliente"
                onClick={handleShowFilters2}
              >
                {keyGan.length > 0 ? (
                  <div className="cards-preview">
                    {keyGan
                      .filter(
                        (val) =>
                          val !== "ATOS" && val !== "CHND" && val !== "RV"
                      )
                      .map((value, index) => (
                        <div className="card-preview" key={index}>
                          <div
                            className="card-preview__text"
                            // onClick={(event) =>
                            //   this.RemoveGroupSelec(event, gs.id)
                            // }
                          >
                            {value === "LV" && "Livre"}
                            {value === "BQ" && "Pausado"}
                            {value === "BQSUPER" && "Bloqueado"}
                            {value === "AT" && "Em Interação"}
                            {value === "ACW" && "AfterCallWork"}
                            {value === "null" && "Inativo"}
                          </div>
                          <div className="card-preview__icon">
                            <i
                              onClick={(event) =>
                                handleRemoveStateSelec(event, value)
                              }
                              className="material-icons"
                            >
                              close
                            </i>
                          </div>
                        </div>
                      ))}
                  </div>
                ) : (
                  "Status"
                )}
                <div className="cards-preview__select-icons">
                  {keyGan.length > 0 && (
                    <IconClose
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveAllState(e);
                      }}
                    />
                  )}
                  <i className="select__icon material-icons">
                    keyboard_arrow_right
                  </i>
                </div>
              </button>
              <div className="options ">
                {/* <!-- Status --> */}
                <div className="options--advanced__filter-box">
                  <div className="options--advanced__filter-box__content">
                    {/* <div className="checkbox__list__title">Status</div> */}
                    <div className="checkbox checkbox__list">
                      <li className="checkbox__item">
                        <input
                          className="checkbox__list__input"
                          defaultChecked={
                            keyGan.findIndex(function (val) {
                              return val === "LV";
                            }) !== -1
                              ? true
                              : false
                          }
                          id="checkbox-LV"
                          name="checkbox-LV"
                          onChange={(event) => handleFilterState(event, "LV")}
                          type="checkbox"
                        />
                        <label htmlFor="checkbox-LV">Livre</label>
                      </li>
                      <li className="checkbox__item">
                        <input
                          className="checkbox__list__input"
                          defaultChecked={
                            keyGan.findIndex(function (val) {
                              return val === "AT";
                            }) !== -1
                              ? true
                              : false
                          }
                          id="checkbox-AT"
                          type="checkbox"
                          onChange={(event) => handleFilterState(event, "AT")}
                          value="Chamada ativa"
                        />
                        <label htmlFor="checkbox-AT">Em Interação</label>
                      </li>
                      <li className="checkbox__item">
                        <input
                          className="checkbox__list__input"
                          defaultChecked={
                            keyGan.findIndex(function (val) {
                              return val === "BQ";
                            }) !== -1
                              ? true
                              : false
                          }
                          id="checkbox-BQ"
                          type="checkbox"
                          onChange={(event) => handleFilterState(event, "BQ")}
                          value="Pausado"
                        />
                        <label htmlFor="checkbox-BQ">Pausado</label>
                      </li>
                      <li className="checkbox__item">
                        <input
                          className="checkbox__list__input"
                          defaultChecked={
                            keyGan.findIndex(function (val) {
                              return val === "ACW";
                            }) !== -1
                              ? true
                              : false
                          }
                          id="checkbox-ACW"
                          type="checkbox"
                          onChange={(event) => handleFilterState(event, "ACW")}
                          value="AfterCallWork"
                        />
                        <label htmlFor="checkbox-ACW">AfterCallWork</label>
                      </li>
                      <li className="checkbox__item">
                        <input
                          className="checkbox__list__input"
                          defaultChecked={
                            keyGan.findIndex(function (val) {
                              return val === "BQSUPER";
                            }) !== -1
                              ? true
                              : false
                          }
                          id="checkbox-BQSUPER"
                          type="checkbox"
                          onChange={(event) =>
                            handleFilterState(event, "BQSUPER")
                          }
                          value="Bloqueado"
                        />
                        <label htmlFor="checkbox-BQSUPER">Bloqueado</label>
                      </li>
                      <li className="checkbox__item">
                        <input
                          className="checkbox__list__input"
                          id="checkbox-null"
                          type="checkbox"
                          defaultChecked={
                            keyGan.findIndex(function (val) {
                              return val === "null";
                            }) !== -1
                              ? true
                              : false
                          }
                          onChange={(event) => handleFilterState(event, "null")}
                          value="Inativo"
                        />
                        <label htmlFor="checkbox-null">Inativo</label>
                      </li>
                    </div>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
        </Drawer>
      </div>
      <div className="canvas__wrapper__footer">
        <div className="block transparent active-chats" id="active-chats">
          <div className="active-chats__tabs">
            <ul className="active-chats__list">
              <ChatSimultComponent chatemcurso={""} remotescreen={"equipes"} />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
